import {
  Text,
  Popover,
  Stack,
  Button,
  Group,
  useMantineTheme,
  FloatingPosition,
  FloatingAxesOffsets,
} from "@mantine/core";
import { useClickOutside, useLocalStorage } from "@mantine/hooks";
import { ReactNode, useEffect, useState } from "react";
import { trackEvent } from "../../common/analytics";

const PromptTip = ({
  children,
  tip,
  name,
  disabled,
  position = "top",
  offset = 10,
}: {
  children: ReactNode;
  tip: ReactNode;
  name: string;
  disabled?: boolean;
  position?: FloatingPosition;
  offset?: number | FloatingAxesOffsets;
}) => {
  const [opened, setOpened] = useState(false);
  const ref = useClickOutside(() => setOpened(false));
  const key = `dismissed-tip-${name}`;
  const [dismissed, setDismissed] = useLocalStorage({
    key,
    defaultValue: false,
  });
  useEffect(() => {
    if (disabled) return;
    // console.log('dismissed :', dismissed);
    if (!dismissed) {
      setOpened(true);
    } else {
      setOpened(false);
    }
  }, [disabled, dismissed]);
  const dismiss = () => {
    trackEvent("dismiss-tip", { name });
    setDismissed(true);
    setOpened(false);
  };
  const theme = useMantineTheme();

  return (
    <Popover
      opened={opened && !disabled}
      width={300}
      position={position}
      offset={offset}
      withArrow
      shadow="md"
    >
      <Popover.Target>{children}</Popover.Target>
      <Popover.Dropdown style={{ borderColor: theme.colors.blue[5] }}>
        <Stack ref={ref}>
          <Text size="xs">{tip}</Text>
          <Group justify="right">
            <Button size="xs" onClick={dismiss}>
              Got it
            </Button>
          </Group>
        </Stack>
      </Popover.Dropdown>
    </Popover>
  );
};
export default PromptTip;
